<template>
  <div class="indexPage">
    <div class="heads">
      <div class="header">
        <div class="head_top">
          <div class="head_lg_re">
              <button @click="toLogin">登陆</button>
              <button @click="goToJoinUs">注册</button>
          </div>
        </div>
        <div class="head_nav">
          <div class="head_nav_center">
            <div class="nav01">
              <img src="@/assets/png/logo-png.png" alt="">
            </div>
            <div class="nav02">
              <div class="nav02_r">
                <div v-for="(item,index) in navdata" :key="index" @click="changeNavData(index)"
                :style="{'background-color':selectIndex==index?'rgb(255,102,55)':'','color':selectIndex==index?'#FFFFFF':''}" 
                >{{item.dec}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slideshow">
      <div class="banner">
        <div class="bannerImg">
          <span v-for="(v,i) in banners" :key="v.id" :style="{opacity:(i+1)==imageIndex?'1':'0',
            backgroundImage:'url('+v.image+')'}" class="active">
            <div v-if="v.id==1" class="index_one">
              <div>
                <p>{{v.maxtitle}}</p>
                <p>{{v.mintitle}}</p>
                <p>{{v.doc1}}</p>
                <p>{{v.doc2}}</p>
              </div>
            </div>
            <div v-if="v.id==2" class="index_two">
              <div class="top">
                <p>{{v.maxtitle}}</p>
                <p>{{v.mintitle}}</p>
                <p>{{v.doc1}}</p>
                <p>{{v.doc2}}</p>
              </div>
            </div>
          </span>
        </div>
        <ul class="bannerBtn clear-fix">
          <li v-for="(num,index) in banners" :key="index" @click="imageIndex=(index+1)">
            <a href="javascript:;" :style="{background:(index+1)==imageIndex?'#ff7800':''}" class='aBtn'></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="viplogin">
      <div class="introduce">
        <div class="introduce_center">
          <div class="introduce_content">
            <b>公司理念:</b><br>
            <span>我们相信：旅游定制是大众市场也是未来旅游的主流市场，每一个独立的需求都是一次客户主动发起的定制。</span><br>
            <span>我们相信：定制就是单项产品的最佳组合方案。</span><br>
            <span>让实现客户的旅游需求从此变的：简单、高效、物美价廉。</span><br>
            <span>我们相信：客户需要的就是高效快速实用的满足需求。</span><br>
          </div>
          <button>了解更多</button>
          <div class="code">
            <img src="@/assets/jpg/xiaochengxu.jpg"/>
            <p>扫描查看手机版网站</p>
          </div>
        </div>
      </div>
      <div class="login_center" id="vipLogin">
        <div class="center_title"><span></span>&nbsp;&nbsp;会员登录</div>
        <div class="lo">
          <div class="lo_c">
            <input type="text" placeholder="账号" v-model="account"/>
            <input :type="lookYN?'text':'password'" placeholder="密码" v-model="password">
            <i class="el-icon-view" :style="{color:lookYN?'red':'gray'}" style="
              position: relative;top: -0.28rem; left: 2.6rem;transform: scale(0.8);" @click.stop="lookYN=!lookYN"></i>
            <button @click="login" @keyup.enter="login">登录</button>
            <div>
              <p @click="$refs.modifyPassword.init()">忘记密码</p><p @click="goToJoinUs()">免费注册</p>
            </div>
          </div>
        </div>
        <div class="atlas">
          <ul>
            <li v-for="(item,index) in image" :key="index"><img :src="item.img"/></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="aboutme">
      <div class="aboutme_center">
        <div class="center_one">
          <b>我们的服务</b>
          <ul>
            <li v-for="(item,index) in weserve" :key="index">
              <img :src="item.img" alt="">
              <p><span>{{item.title}}</span></p>
              <p>{{item.doc1}}</p>
              <p>{{item.doc2}}</p>
              <p>{{item.doc3}}</p>
            </li>
          </ul>
        </div>
        <div class="center_two">
          <b>关于我们的优势</b>
          <p>20年的积累的案例，不断简易化的定制流程，资源直采的获利方式，不断</p>
          <p>满足客户及旅游同业的需求，真诚为您服务</p>
          <ul>
            <li v-for="(item,ind) in advantage" :key="ind">
              <img :src="item.img" alt="">
              <p>{{item.num}}</p>
              <p>{{item.doc}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="list">
        <ul>
          <li v-for="(item,index) in listdata" :key="index">
            <img :src="item.img" alt="">
            <div>
              <p>{{item.doc1}}</p>
              <p>{{item.doc2}}</p>
              <span>{{item.doc3}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="bottom">
        <div>
          <p><span>“</span>&nbsp;&nbsp;&nbsp;&nbsp;每一个品牌都是一个产品,但不是所有的产品&nbsp;&nbsp;&nbsp;&nbsp;<span>”</span></p>
          <p>都是品牌~</p>
        </div>
      </div>
    </div>
    <div class="joinus" id="joinus">
      <div class="joinus_center">
        <div class="comment">
          <ul>
            <li v-for="(item,index) in commentdata" :key="index">
              <img :src="item.img" alt="">
              <div>
                <p>{{item.doc}}</p>
                <p>{{item.name}}</p>
              </div>
            </li> 
          </ul>
        </div>
        <!-- 商户入驻信息 -->
        <SettleInfo></SettleInfo>
      </div>
      <div class="bot">
        <div>
          <p>给你不一样的体验价值</p>
          <span>旅游行业从业超过20年！</span>
          <span>我们了解大中小型旅游企业的经营模式和需求</span>
          <span>我们倡导让客户感知产品的体验价值，而<br/>不仅仅是产品的功能。</span>
          <span>更小投入、更低难度、更高效率、更优成本、更高颜<br/>值、更多客户</span>
          <button>了解详情</button>
        </div>
      </div>
      <div class="bot1">
        <b>联系我们</b>
        <p>如有任何问题请联系我们，我们7*24小时竭诚为您服务</p>
        <p>000-000-0000</p>
      </div>
    </div>
    <div class="footer">
      <div class="bot2">
        <div style="margin-top:20px;">
          <span ><a href="https://beian.miit.gov.cn/" target="_blank" style="font-size: 0.12rem;color:#8B989D">备案号：京ICP备16056012号-5</a></span>
        </div>
        <div class="bot2_center">
          <ul>
            <li v-for="(item,index) in botinfo" :key="index">
              <img :src="item.img" alt="">&emsp;
              <p>{{item.doc}}</p>
            </li>
          </ul>
        </div>
        <p style="color:gray;margin-top:10px;font-size: 0.12rem;">手机版|本站使用|管理登录</p>
      </div>
    </div>
    <modifyPassword ref="modifyPassword"></modifyPassword>
  </div>
</template>
<script>
import Api from '@/components/Api/index.js'
import SettleInfo from '@/views/loginViews/SettleInfo'
import modifyPassword from './loginViews/children/modifyPassword.vue'
export default {
  data(){
    return{
      navdata:[
        {dec:'首页',link:''},
        {dec:'案例展示',link:''},
        {dec:'加入我们',link:''},
        {dec:'联系我们',link:''},
        {dec:'新闻资讯',link:''},
        {dec:'关于我们',link:''},
      ],
      selectIndex:0,
      banners:[
        {
          id:1,
          image:require('../assets/jpg/banner1.jpg'),
          maxtitle:'定制  ●  简单',
          mintitle:'旅行商品的按需组合团购方案',
          doc1:'以定制案例内容、丰富旅游产品资源、智能一键采购、资源共享经济、激发创意快速设计、智能化定制技术、AI旅游定制服务为核心的互联网旅游平台',
          doc2:''
        },
        {
          id:2,
          image:require('../assets/jpg/banner2.jpg'),
          maxtitle:'Idea',
          mintitle:'灵感无处不在',
          doc1:'3分钟完成一个旅游定制方案',
          doc2:'一个帮您迅速呈现灵感的平台'
        },
      ],
      imageIndex:1,// 图片的index。
      image:[
        {img:require('@/assets/jpg/pic1.jpg')},
        {img:require('@/assets/jpg/pic2.jpg')},
        {img:require('@/assets/jpg/pic3.jpg')},
        {img:require('@/assets/jpg/pic4.jpg')},
        {img:require('@/assets/jpg/pic5.jpg')},
        {img:require('@/assets/jpg/pic6.jpg')},
      ],
      account:null,
      password:null,
      lookYN:false,
      weserve:[
      {img:require('@/assets/jpg/serve1.jpg'),
        title:'定制旅游案例模板库',
        doc1:'旅游共享时代主义',
        doc2:'让旅游人的偷懒',
        doc3:'变的理直气壮'
      },
      {img:require('@/assets/jpg/serve2.jpg'),
        title:'PC端模块化定制设计工具',
        doc1:'零基础+好用+好看',
        doc2:'降低定制师操作难度',
        doc3:'激发消费者购买欲望'
      },
      {img:require('@/assets/jpg/serve3.jpg'),
        title:'PC端资源采购系统',
        doc1:'好看的皮囊千篇一律',
        doc2:'有趣的灵魂万里挑一',
        doc3:'产品靠谱才能达成交易获得收益'
      },
      {img:require('@/assets/jpg/serve4.jpg'),
        title:'移动端形象策略',
        doc1:'用画面让产品和服务说话',
        doc2:'从无到有，从有到更好',
        doc3:'定制师IP时代'
      },],
      advantage:[
        {
          img:require('@/assets/jpg/about1.jpg'),
          num:'18250',
          doc:'现有案例'
        },
        {
          img:require('@/assets/jpg/about2.jpg'),
          num:'100000+',
          doc:'资源数据'
        },
        {
          img:require('@/assets/jpg/about3.jpg'),
          num:'6000+',
          doc:'客户好评'
        },
        {
          img:require('@/assets/jpg/about4.jpg'),
          num:'7000+',
          doc:'方案询单'
        },
      ],
      listdata:[
        {
          img:require('@/assets/jpg/list1.jpg'),
          doc1:'方案库',
          doc2:'拷贝、调整、转发',
          doc3:'（告别费时费力做不好）'
        },
        {
          img:require('@/assets/jpg/list2.jpg'),
          doc1:'一眼看清预算',
          doc2:'产品随意组合拆分',
          doc3:'（独一无二的操作体验）'
        },
        {
          img:require('@/assets/jpg/list3.jpg'),
          doc1:'购买预算',
          doc2:'按需采购',
          doc3:'（独一无二的采购方式）'
        },
        {
          img:require('@/assets/jpg/list4.jpg'),
          doc1:'和资源直接询价',
          doc2:'迅速 高效 价低',
          doc3:'（专属产品 专为您准备的特价）'
        },
      ],
      commentdata:[
        {
          img:require('@/assets/png/comment1.png'),
          doc:'门店小妹给客户做一个行程只需要几分钟，轻松获客。',
          name:'于总'
        },
        {
          img:require('@/assets/png/comment1.png'),
          doc:'定制师很快就发来了专属方案，我加上其他产品发给客户，成交！',
          name:'小迪'
        },
        {
          img:require('@/assets/png/comment3.png'),
          doc:'企业竞标，单独询酒店团队房和团队机票，资源方直接报价，拿单！',
          name:'商旅专家'
        },
        {
          img:require('@/assets/png/comment4.png'),
          doc:'五分钟一个漂亮的定制方案发给客户，以前一天做十个团，现在效率翻了十倍。',
          name:'地接达人'
        }
      ],
      timer:null,
      botinfo:[
        {
          img:require('@/assets/jpg/icon1.jpg'),
          doc:'XXX省XXX市XXX县XXX路XXX号'
        },
        {
          img:require('@/assets/jpg/icon2.jpg'),
          doc:'联系电话：020-000000'
        },
        {
          img:require('@/assets/jpg/icon3.jpg'),
          doc:'工作时间：09:00—18：00'
        },
        {
          img:require('@/assets/jpg/icon4.jpg'),
          doc:'xxx@.co.m'
        },
      ]
    }
  },
  components: {SettleInfo,modifyPassword},
  methods:{
    toLogin(){
      document.getElementById('vipLogin').scrollIntoView()
    },
    handleEnter(event) {
      if (event.key === 'Enter') {
        this.login();
      }
    },
    goToJoinUs(){
      document.getElementById('joinus').scrollIntoView()
    },
    GetQueryString(name){
      var  reg = new  RegExp( "(^|&)" + name + "=([^&]*)(&|$)" );
      var  r = window.location.search.substr(1).match(reg);
      if (r!= null ) return   unescape(r[2]); return  null ;
    },
    //免密登录
    confidentiality() {
      let code = this.GetQueryString("code");
      if(code != null && code != undefined && code !== ''){
        new Api("oauth").exchangeForToken(code).then(res => {
          if (res.status == 200) {
              let _obj = {
                phoneNumber: res.data.phoneNumber,
                companyName: res.data.companyName,
                imageUrl: res.data.imageUrl,
                name: res.data.name,
                supplierKey: res.data.supplierKey,
                officialAccount:res.data.officialAccount,
              }
              this.$store.commit('setUserInfo',_obj)
              this.$store.commit('setAccessToken', res.data.accessToken)
              this.$store.commit('setRefreshToken', res.data.refreshToken)
              localStorage.setItem('tokenTime',JSON.stringify(res.data.exp * 1000 + Date.now())) //用当前时间加上俩个小时
              this.$router.push({name: res.data.finalRedirect,query: {companyId: res.data.companyId}})
            }
        })
      }
    },
    async login(){
      const res = await new Api('oauth').userLoginNew({"username":this.account,"password":this.password})
      if (res.status == 200) {
        this.$store.commit('setNewAccessToken', res.data.accessToken)
      }

      const resOld = await new Api('oauth').userLogin({"username":this.account,"password":this.password})
      if (resOld.status == 200 && resOld.data.mechanismId != '-10') {
          this.$store.commit('setAccessToken', resOld.data.accessToken)
          this.$store.commit('setRefreshToken', resOld.data.refreshToken)
          this.$store.commit('setUserInfo', resOld.data)
          this.$store.commit('setPlanId', null)
          this.$store.commit('setCheckIndex', 0)
          localStorage.setItem('tokenTime',JSON.stringify(resOld.data.exp * 1000 + Date.now())) //用当前时间加上俩个小时
          this.$router.push({name:'newNavBar'})

          this.$message({
            type: "success",
            message: resOld.statusText,
            duration:500
          }); 
        }
        else {
          this.$message({
            type: "error",
            message: '账号或密码错误！',
          });
        }

    },
    changeNavData(index){
      this.selectIndex = index
      if(index==2){//加入我们
        document.getElementById('joinus').scrollIntoView()
      }
    }
  },
  mounted(){
    window.addEventListener('keyup', this.handleEnter);
    this.confidentiality()
    this.timer = setInterval(() => {
    //需要定时执行的代码
      this.imageIndex = this.imageIndex==1?2:1
    }, 4000)
  },
  beforeDestroy(){
    clearInterval(this.timer)
    window.removeEventListener('keyup', this.handleEnter);
  }
}
</script>
<style lang="scss" scoped>
.indexPage{
  overflow-x: hidden;
  height: 100vh;
}
.heads{
  .header{
    .head_top{
      background-color: rgb(247,247,247);
      .head_lg_re{
        height: 0.4rem;
        display: flex;
        justify-content: flex-end;
        width: 14rem;
        button{
          width: 1rem;
          height:0.3rem;
          margin: 0.06rem 0.06rem 0 0;
        }
        button:nth-child(1){
          background-color: white;
          color: gray;
          border: 1px solid rgb(218,218,218);
        }
        button:nth-child(2){
          color:white;
          background-color: rgb(69,162,255);
          border: none;
        }
      }
    }
    .head_nav{      
      .head_nav_center{
        display:flex;
        justify-content: center;
        height: 1.2rem;
        .nav01{ 
          display:flex;
          align-items: center;
          margin-right: 1.5rem;
          img{
            height: 1rem;
          }
        }
        .nav02{
          z-index: 1;
          .nav02_r{
            display: flex;
            div{
              margin-left: 0.1rem;
              position: relative;
              top: 0.4rem;
              width: 1.4rem;
              height: 1.2rem;
              font-size: 0.16rem;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            div:hover{
              background-color: rgb(255,102,55);
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
}
.banner{
  position: relative;
  .bannerImg{
    height: 7rem;
    span{
      position: absolute;
      width: 100%;
      background-size: 100% 100%;
      height: 7rem;
    } 
    .index_one{
      color: white;
      display: flex;
      justify-content: center;
      height: 100%;
      align-items: center;
      div{
        width: 6.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        p:nth-child(1){
          font-size: 0.7rem;
          margin-bottom: 20px;
        }
        p:nth-child(2){
          font-size: 0.3rem;
          margin-bottom: 40px;
        }
        p:nth-child(3){
          font-size: 0.2rem;
        }
      }
    }
    .index_two{
      display: flex;
      height: 100%;
      align-items: center;
      padding-left: 3.7rem;
      div{
        p:nth-child(1){
          font-size: 0.9rem;
          margin-bottom: 20px;
          font-family: "Times New Roman", 微软雅黑;
          font-weight: bold;
        }
        p:nth-child(2){
          font-size: 0.65rem;
          margin-bottom: 80px;
        }
        p:nth-child(3){
          color: #9F1431;
          font-size: 0.34rem;
          font-family: "\601D\6E90\9ED1\4F53 CN Light", 微软雅黑;
          margin-bottom: 10px;
        }
        p:nth-child(4){
          font-size: 0.3rem;
          font-family: "\601D\6E90\9ED1\4F53 CN Light", 微软雅黑;
          margin-bottom: 10px;
        }
      }
    }
  }
  .bannerBtn{
    position: absolute;
    left: 46%;
    bottom: 12px;
    li{
      margin: 0 13px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      float:left;
      background: rgba(255,255,255,.4);
      display: flex;
      align-items: center;
      justify-content: center;
      a{
        width: 15px;
        height: 15px;
        display: inline-block;
        border-radius: 50%;
      }
    }
  }
}
.viplogin{
  background-color: #ebebeb;
  .introduce{
    height: 2rem;
    background-color: #222222;
    display: flex;
    align-items: center;
    .introduce_center{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 1.6rem;
      .introduce_content{
        color:#FFFFFF;
        b{
          font-size: 0.24rem;
          display: inline-block;
          margin-bottom: 5px;
        }
        span{
          font-size: 0.14rem;
          display: inline-block;
          margin-bottom: 3px;
        }
      }
      button{
        width: 1.6rem;
        height: 0.5rem;
        background-color: white;
        border: 1px solid gray;
        border-radius: 30px;
        margin-left: 1.5rem;
        font-size: 0.16rem;
        margin-right: 0.2rem;
      }
      .code{
        text-align: center;
        img{
          width: 1.2rem;
          height: 1.2rem;
        }
        p{
          color: #666666;
          font-size: 0.14rem;
          margin-top: 0.05rem;
        }
      }
    }
  }
  .login_center{
    background-color: white;
    width: 11.6rem;
    margin: 0 auto;
    .center_title{
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.45rem;
      border-bottom: 1px solid rgb(204, 204, 204);
      color: #FF6637;
      padding-left: 5px;
      font-size: 0.16rem;
      span{
        width:5px;
        height: 16px;
        background-color: #FF6637;
      }
    }
    .lo{
      display: flex;
      justify-content: center;
      width: 100%;
      padding: 5px;
      .lo_c{
        width: 2.8rem;
        input{
          width: 100%;
          height: 0.35rem;
          background-color: rgb(233, 233, 233);
          border: 1px solid rgb(218, 217, 217);
          border-radius: 2px;
          padding-left: 0.4rem;
          margin-top: 10px;
        }
        input:nth-child(1){
          background-image: url('../assets/png/zh.png');
          background-size: auto 0.3rem;
          background-position-y: center;
          background-repeat: no-repeat;
        }
        input:nth-child(2){
          background-image: url('../assets/png/password.png');
          background-size: auto 0.25rem;
          background-position-y: center;
          background-repeat: no-repeat;
        }
        button{
          width: 100%;
          height: 0.45rem;
          color: white;
          background-color: rgb(254,90,89);
          border:1px solid rgb(231, 53, 53);
          border-radius: 5px;
          font-size: 0.15rem;
        }
        div{
          display: flex;
          justify-content: space-between;
          height: 30px;
          border-bottom: 1px solid rgb(229,229,229);
          color: #666666;
          align-items: center;
          p{
            cursor: pointer;
          }
        }
      }
    }
  }
  .atlas{
    ul{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0px 5px;
      li{
        margin-bottom: 7px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      li:nth-child(1),li:nth-child(2),li:nth-child(5),li:nth-child(6){
        width: 4.25rem;
        height: 2.5rem;
      }
      li:nth-child(3),li:nth-child(4){
        width: 2.8rem;
        height: 2.5rem;
      }
    }
  }
}  
.aboutme{
  .aboutme_center{
    padding-top: 90px;
    padding-bottom: 60px;
    .center_one{
      text-align: center;
      >b{
        font-size: 0.35rem;
      }
      >ul{
        margin-top: 60px;
        display: flex;
        justify-content: center;
        >li{
          padding: 0px 0.25rem;
          >img{
            width: 1.2rem;
          }
          >p:nth-child(2){
            font-size: 0.25rem;
            margin-top: 20px;
          }
          >p:nth-child(n+3){
            margin-top: 10px;
            color: #999;
            font-size: 0.12rem;
          }
        }
      }
    }
    .center_two{
      margin-top: 90px;
      text-align: center;
      >b{
        font-size: 0.35rem;
      }
      >p{
        color: #999;
        font-size: 0.14rem;
      }
      >p:nth-child(2){
        margin-top: 15px;
      }
      >p:nth-child(3){
        margin-top: 10px;
      }
      >ul{
        display: flex;
        justify-content: center;
        >li{
          padding: 0px 0.6rem;
          >img{
            width: 1.1rem;
            margin-top: 20px;
            height: 0.7rem;
          }
          >p:nth-child(2){
            color: red;
            margin-top: 20px;
            font-size: 0.4rem;
            font-weight: bold;
          }
          >p:nth-child(3){
            color: #999;
            font-size: 0.14rem;
            margin-top: 20px;
          }
        }
      }
    }
  }
  .list{
    background-color: #ebebeb;
    padding: 60px;
    >ul{
      display: flex;
      justify-content: center;
      >li{
        padding: 0 0.1rem;
        >img{
          width: 2.7rem;
          height: 1.7rem;
        }
        >div{
          background-color: #FFFFFF;
          padding: 0.48rem 0px;
          text-align: center;
          font-size: 0.12rem;
          >p:nth-child(2){
            margin-top: 6px;
          }
          >span{
            color: #999;
            display: inline-block;
            margin-top: 10px;
            transform: scale(0.8);
          }
        }
      }
    }
  }
  .bottom{
    background-image: url('../assets/jpg/ht.jpg');
    height: 300px;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    >div{
      >p{
        font-size: 0.3rem;
        color: #FFFFFF;
        margin-bottom: 10px;
        text-align: center;
        >span{
          color: #F13A3A;
          font-family: "arial black", "avant garde";
          font-size: 0.7rem;
        }
      }
    }
  }
}
.joinus{
  .joinus_center{
    .comment{
      margin: 50px 0px;
      >ul{
        display: flex;
        justify-content: center;
        >li{
          padding: 0px 0.5rem;
          >img{
            width: 1.9rem;
          }
          >div{
            display: flex;
            justify-content: center;
            height: 190px;
            margin-top: 20px;
            >p{
              writing-mode: tb;
            }
            >p:last-child{
              font-size: 0.26rem;
            }
            >p:first-child{
              font-size: 0.14rem;
              color: #666666;
              margin-right: 0.1rem;
              margin-top: 3px;
              line-height: 25px;
            }
          }
        }
      }
    }
  }
  .bot{
    display: flex;
    align-items: center;
    width: 100%;
    height: 5.8rem;
    background-image: url('../assets/jpg/tl.jpg');
    background-size: 100% 100%;
    margin-top: 120px;
    justify-content: flex-end;
    div{
      display: flex;
      flex-direction: column;
      width: 8.5rem;
      p{
        font-size: 0.38rem;
        color: #FFFFFF;
        margin: 20px 0;
      }
      span{
        font-size: 0.16rem;
        color: #FFFFFF;
        line-height: 30px;
      }
      button{
        width: 1.6rem;
        height: 0.57rem;
        background-color: white;
        color: #000000;
        font-size: 0.14rem;
        border-radius: 25px;
        margin-top: 40px;
      }
    }
  }
  .bot1{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-bottom: 80px;
    b{
      font-size: 0.32rem;
      color: #333333;
      margin: 50px 0 30px 0;
    }
    p:nth-child(2){
      color:#666666;
      font-size:0.16rem;
      margin: 10px 0 10px 0;
    }
    p:nth-child(3){
      color:#333333;
      font-size:0.26rem;
    }
  }
}
.footer{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .bot2{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 1.9rem;
    background-color: #222222;
    .bot2_center{
      width: 1200px;
      display: flex;
      ul{
        display: flex;
        width: 100%;
        li{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 300px;
          border-bottom: 1px solid gray;
          font-size: 0.14rem;
          color: #8B989D;
          padding: 0.35rem 0px;
          img{
            width: auto;
            height: auto;
          }
        }
      }
    }
  }
}
</style>